import { z } from "zod";

export const logoutSchema = z
	.object({
		refresh_token: z.string().optional(),
		revoke_all: z.boolean().optional(),
	})
	.optional();

export type LogoutPayload = z.infer<typeof logoutSchema>;
